export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      MentorCount: 12,
      ProMentorCount: 2,
      ClientCount: 22,
      UserCount: 36,
      CategoryCount: 9,
      SoudanCount: 21,
      AdminMemo: 'メモ'
    }
  }
}